// import { div, span } from '@tarojs/components';
import classNames from 'classnames';
import styles from './index.module.less';

function PrivacyPolicyZH() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.serviceAgreement}>
        <div className={styles.title}>Last Updated: 10.30.2023</div>
        <div className={styles.title}>Introduction</div>
        <div>
          Thank you for choosing our products and services! Carbonstop (Beijing)
          Co., Ltd. (hereinafter referred to as "Carbonstop", "we" or “us”) is
          committed to the protection of your privacy and Personal Information.
          We will protect the right to privacy of all users (hereinafter
          referred to as "you") who use our services in accordance with legal
          and regulatory requirements. In order to provide you with more
          accurate and personalized services, we will process and use your
          personal information in accordance with the Privacy Policy
          (hereinafter referred to as "this Policy" or "this Privacy Policy").
        </div>

        <div className={styles.title}>
          This Privacy Policy will help you understand the following:
        </div>
        <div>- How we collect and use your personal information;</div>
        <div>- How we use cookies and similar technologies;</div>
        <div>
          - How we share, transfer and publicly disclose your personal
          information;
        </div>
        <div>- How we protect and keep your personal information;</div>
        <div>- Your rights;</div>
        <div>- How we process minor’s personal information;</div>
        <div>- How your personal information is transferred globally;</div>
        <div>- How we update this Policy;</div>
        <div>- How to contact us.</div>

        <div className={styles.title}>
          This Privacy Policy applies to Carbonstop Website and the products and
          services provided by Carbonstop.
        </div>

        <div>
          In compliance with applicable laws and regulations, we will collect,
          use, and share your personal information to provide you with
          Carbonstop products and services and continuously improve the quality
          of products and services, and we will ensure the security of your
          personal information. Before using our products or services, please be
          sure to read carefully and fully understand this{' '}
          <div className={classNames(styles.underline, styles.bold)}>
            Policy, especially the terms marked in bold/in bold with underline.
          </div>{' '}
          You shall read it carefully and confirm that you fully understand and
          agree before starting to use our products or services.
        </div>

        <div className={styles.title}>Definitions</div>
        <div>
          1. <span className={styles.bold}>Carbonstop</span>: refers to
          Carbonstop (Beijing) Technology Co., Ltd., which develops and provides
          our products and services, as well as any relevant affiliates
          established now or in the future, either individually or collectively.
        </div>
        <div>
          2. <span className={styles.bold}>Carbonstop Products/Services</span>:
          refers to Carbon AI, which is developed and serviced by us, to help
          customers carry out safe and efficient carbon data quantification
          services, and to assist enterprises in green and sustainable
          development.
        </div>
        <div>
          3. <span className={styles.bold}>Carbonstop Website</span>: refers to
          the internet addresses where we provide Services to Users, including
          the official website (www.carbonstop.com) and the Ccloud SaaS
          (ccloud.carbonstop.com).
        </div>
        <div>
          4. <span className={styles.bold}>Personal Information</span>: refers
          to all kinds of information related to identified or identifiable
          natural persons recorded by electronic or other means, excluding the
          information handled anonymously.
        </div>
        <div>
          5. <span className={styles.bold}>Sensitive Personal Information</span>
          : refers to the personal information that is likely to result in
          damage to the personal dignity of any natural person or damage to his
          or her personal or property safety once disclosed or illegally used,
          including such information as biometric identification, religious
          belief, specific identity, medical health, financial account and
          whereabouts and tracks, as well as the personal information of minors
          under the age of 14. In this Privacy Policy, it also includes network
          tracking, precise location information, and transaction records.
        </div>
        <div>
          6.{' '}
          <span className={styles.bold}>Deletion of personal information</span>:
          refers to the act of removing personal information from the system
          involved in daily business operations so that it remains unavailable
          for retrieval and access.
        </div>

        <div>
          <div className={styles.title}>
            How we collect and use your personal information
          </div>
          <div>
            In order to provide you with the basic functions of Carbonstop
            Products/Services, we need to collect and use your necessary
            personal information. If you refuse to provide the aforementioned
            information, you will not be able to use the essential features of
            Carbonstop Products/Services. For personal information that you have
            the option to provide, if you refuse to provide such information, we
            might not be able to offer you some specific features that rely on
            this information. However, this will not affect your use of basic
            functions of Carbonstop Products/Services.
          </div>
          <div>
            We will collect your personal information in the following scenarios
            when we provide products and/or services based on the principles of
            legitimacy, legality, and necessity. If the personal information you
            provide is not your own information, you shall ensure that you have
            obtained the authorization of the person.
          </div>
        </div>

        <div className={styles.title}>Display of Service information</div>
        <div>
          During your use of our products/services, in order to ensure the
          normal operation of our services, we will collect{' '}
          <span className={styles.bold}>
            your device name (including aliases), device model, operating
            system, IP address, device software version information,
            international mobile equipment identity (IMEI), mobile equipment
            identifier (MEID), information location, network usage habits and
            other log information related to the Carbonstop Service,
          </span>{' '}
          which is the basic information that must be collected for the purpose
          of providing services. If you do not agree with our collection of the
          aforementioned information, we may not be able to complete risk
          control verification.
        </div>
        <div>
          <span className={styles.bold}>
            Please note that individual device information and log information
            are information that cannot identify a specific natural person.
          </span>{' '}
          If we combine such non-personal information with other information to
          identify a specific natural person or combine it with personal
          information, such non-personal information will be regarded as
          personal information during the combination period, and we will
          anonymize and de-identify such personal information unless we have
          obtained your authorization or are otherwise provided by laws and
          regulations.
        </div>

        <div className={styles.title}>Account registration</div>
        <div>
          When registering for the Carbonstop Services, you need to provide{' '}
          <span className={styles.bold}>
            your mobile phone number, email address, name, company name,
            password, or verification code
          </span>{' '}
          to create an account and complete the registration. If you modify the
          account information during the use of our service, the modified
          information will also be synchronized to your account. If you do not
          agree to provide the above information, we may not be able to create
          an account for you and provide services normally. For services that
          need to be used by logging into an account, we may verify your
          identity based on the above information you provide to ensure that we
          are providing services for you personally.
        </div>

        <div className={styles.title}>Quick login</div>
        <div>
          When you log in with your phone number or email, we will send a
          verification code to the reserved phone number or email to facilitate
          your quick login and ensure the security of your account.
        </div>

        <div className={styles.title}>Message push</div>
        <div>
          You need to fill in{' '}
          <span className={styles.bold}>your email address</span>, and we will
          classify and send service information based on your actual use of the
          service through email or on-site messaging, including supplier
          management, task reminders, etc. If you refuse to provide such
          relevant information, we may not be able to provide the above services
          for you.
        </div>

        <div className={styles.title}>
          Customer service and dispute resolution
        </div>
        <div>
          When you contact us, we may keep your communication/call records and
          content or the contact information you provide, in order to contact
          with you or help you solve problems, or to record the solutions and
          results of related issues.
        </div>

        <div className={styles.title}>User invitations</div>
        <div>
          When you invite other users to join us, you need to fill in their
          names, mobile phone numbers, or email addresses after obtaining legal
          and valid authorization from them, and this information will only be
          used to send invitations or other information to your contacts. You
          can also add some personal information to your contacts yourself. We
          guarantee that this information will only be accessible to you. The
          information you provide for your contact person shall also be governed
          by this Privacy Policy.
        </div>

        <div className={styles.title}>Other purposes</div>
        <div>
          When we use information for other purposes not specified in this
          Policy, or use the information collected for specific purposes for
          other purposes, we will seek your consent in advance.
        </div>

        <div className={styles.title}>Exceptions to obtaining consent</div>
        <div>
          According to the requirements of applicable laws, regulations, and
          standards, we may collect and use your personal information without
          seeking your consent if:
        </div>

        <div className={styles.title}>
          In the event that we discontinue providing Carbonstop
          Products/Services
        </div>
        <div>
          If we discontinue providing Carbonstop Products/Services, we will stop
          collecting and using your personal information promptly, notify you of
          the cessation of operation in the form of a notice or announcement,
          and delete or anonymize the personal information we hold.
        </div>

        <div className={styles.title}>
          How we use cookies and similar technologies
        </div>
        <div>
          In order to ensure the normal operation of the website and provide you
          with an easier experience, we store small data files called cookies on
          your computer or mobile device. Cookies typically contain identifiers,
          site names, and some numbers and characters. We do not store
          personally identifiable or privacy-related information in cookies.
        </div>
        <div>
          You can manage or delete cookies according to your preferences. For
          details, see AboutCookies.org. You can erase all cookies saved on your
          computer, and most web browsers have a function to block cookies.
          However, if you do so, you will need to change your user settings each
          time you visit our website. For more information on how to change your
          browser settings, please visit the settings page of the browser you
          are using.
        </div>

        <div className={styles.title}>
          How we share, transfer and publicly disclose your personal information
        </div>
        <div className={styles.title}>- Sharing</div>
        <div>
          We will not share your personal information with companies,
          organizations, and individuals other than service providers of
          Carbonstop, except in the following cases:
        </div>
        <div>
          1. Sharing with your explicit authorization or consent. With your
          explicit consent, we will share your personal information with other
          parties.
        </div>
        <div>
          2. Sharing under legal circumstances. We may share your personal
          information with other parties in accordance with laws and
          regulations, in response to mandatory requests made by administrative
          or judicial authorities in accordance with the law.
        </div>
        <div>
          3. To the extent necessary to provide you with Carbonstop
          Products/Services, we will update this Policy accordingly if we
          subsequently make arrangements to share your personal information with
          authorized partners.
        </div>

        <div className={styles.title}>- Transfer</div>
        <div>
          We will not transfer your personal information to any companies,
          organizations, or individuals, except in the following cases:
        </div>
        <div>
          1. Transfer with explicit consent: After obtaining your explicit
          consent, we will transfer your personal information to other parties.
        </div>
        <div>
          2. In the event of a merger, acquisition, or bankruptcy liquidation of
          a service provider of Carbonstop, or any other situations involving a
          merger, acquisition, or bankruptcy liquidation that involves the
          transfer of personal information, we will require the new company or
          organization that holds your personal information to continue to be
          bound by this Policy. Otherwise, we will require the company,
          organization, or individual to seek authorization from you again.
        </div>

        <div className={styles.title}>- Public disclosure</div>
        <div>
          We will only publicly disclose your personal information in the
          following circumstances:
        </div>
        <div>
          1. With your explicit consent or based on your active choice, we may
          publicly disclose your personal information;
        </div>
        <div>
          2. We may publicly disclose your personal information when required to
          do so by law, legal process, litigation, or mandatory requests from
          government authorities. We will promptly notify you of any request for
          disclosure by a law enforcement agency, unless the law enforcement
          agency requests otherwise that disclosure is prohibited.
        </div>

        <div className={styles.title}>
          - Exceptions to obtaining consent prior to the sharing, transfer or
          public disclosure of personal information
        </div>
        <div>
          In the following cases, sharing, transferring, and publicly disclosing
          your personal information do not require your prior authorization and
          consent:
        </div>
        <div>
          1. The information is related to public safety, public health, or
          major public interests;
        </div>
        <div>
          2. The information is related to criminal investigation, prosecution,
          trial, and execution of judgments;
        </div>
        <div>3. The information has been made public by yourself;</div>
        <div>
          4. The sharing, transferring, or disclosing of your information is
          necessary to protect your or other individuals&apos; legitimate rights
          and interests, life safety, and property safety, and your
          authorization for collecting such information cannot be obtained for
          some reason;
        </div>
        <div>
          5. Other situations to safeguard public interest, such as when your
          credit evaluation information needs to be disclosed/shared;
        </div>
        <div>
          6. The information is collected from legally publicly disclosed
          information, such as legitimate news reports, governmental
          announcements, and other public channels, except where you expressly
          refuse or the processing of such information infringes upon your major
          interests.
        </div>
        <div className={classNames(styles.title, styles.underline)}>
          According to the law, sharing and transferring de-identified personal
          information and ensuring that the recipient of the data cannot recover
          and re-identify the subject of the personal information does not
          constitute an act of sharing, transfer, and public disclosure of
          personal information. Storage and processing of this kind of data may
          not require your consent.
        </div>
        <div className={styles.title}>- Provide proof</div>
        <div>
          For legal documents signed through Carbonstop Website, Carbonstop has
          the right to disclose the signing information of the above-mentioned
          legal documents to the contracting party of the data message as
          evidence of signing the legal document, including the name of the
          party, the unified social credit code (or the organization code), the
          ID card number, the digital certificate number, the IP address, the
          signing time, etc.
        </div>

        <div className={styles.title}>
          How we store and protect your personal information
        </div>
        <div className={styles.title}>Storage of personal information</div>
        <div className={styles.title}>
          1. Storage Period: We will retain your personal information only for
          the period necessary to achieve the purposes described in this Policy,
          unless a longer retention period is compulsorily required by law. We
          determine the storage period of personal information mainly based on
          the following standards, whichever is longer:
        </div>
        <div>
          (i) to complete the transaction with you, and maintain the
          corresponding transaction and business records, in order to respond to
          your inquiries or complaints;
        </div>
        <div>
          (ii) to ensure the safety and quality of services provided to you;
        </div>
        <div>(iii) the longer retention period you have agreed;</div>
        <div>
          (iv) the requirements of any other special agreements or regulatory
          provisions on the retention period;
        </div>
        <div>
          Upon expiration of the retention period, we will delete or anonymize
          your personal information as required by the applicable law. When you
          cancel your account, we will process the data in accordance with the
          requirements of laws and regulations.
        </div>
        <div>
          2. Storage Location: The personal information we collect and generate
          in the course of our operations within the territory of the People's
          Republic of China will be stored in China, except the following
          circumstances:
        </div>
        <div>
          (1) There are explicit provisions in the applicable laws and
          regulations.
        </div>
        <div>
          (2) We will inform you of the relevant information of the overseas
          recipient (such as the name and contact information of the overseas
          recipient, the purpose, method, and type of processing your personal
          information, as well as the manner and procedures for exercising your
          rights to the overseas recipient, etc.), and obtain your explicit
          authorization.
        </div>
        <div>
          Under the above circumstances, we will ensure that your personal
          information will be protected with sufficient equivalent protection
          within the territory of the People's Republic of China in accordance
          with this Policy.
        </div>
        <div>
          3. Termination of operation: In the event of termination of operation,
          we will notify you at least 30 days in advance, and process your
          personal information in accordance with the requirements of laws and
          regulations after terminating the operation.
        </div>

        <div className={styles.title}>
          How we protect your personal information
        </div>
        <div>
          1. We have adopted security measures that comply with industry
          standards to protect personal information against unauthorized access,
          public disclosure, use, modification, damage, or loss. We use SSL
          (Secure Socket Layer) encryption protection technology when data (such
          as credit card information) is exchanged between your browser and the
          &quot;Service&quot;. We provide https (Hyper span Transfer Protocol
          over Secure Socket Layer) secure browsing to the website itself, to
          protect the security of your data in transit. We use encryption
          technology to encrypt and store personal information to ensure data
          confidentiality. We will use trusted protection mechanisms to prevent
          malicious attacks on personal information. We will deploy access
          control mechanisms to ensure that only authorized personnel can access
          personal information. We will hold security and privacy protection
          training courses to enhance employees' awareness of the importance of
          protecting personal information.
        </div>
        <div>
          2. We have obtained the following certifications: Level 3
          Certification for Information System Security Protection, and ISO/IEC
          27001 Information Security Management System Certification.
        </div>
        <div>
          3. We will take reasonable and feasible measures to avoid collecting
          irrelevant personal information.{' '}
          <span className={classNames(styles.underline, styles.bold)}>
            We will only retain your personal information for the period
            necessary to achieve the purposes stated in this Policy, unless we
            need to extend the retention period or we are allowed by law.
          </span>
        </div>
        <div>
          4. The internet is not an absolutely secure environment,{' '}
          <span className={classNames(styles.bold, styles.underline)}>
            and we strongly recommend that you do not use communication methods
            which are not recommended by us to send personal information.
          </span>{' '}
          Please protect your personal information properly and only provide it
          to others when necessary. If you find that your personal information,
          especially your account or password, has been leaked, please contact
          our customer service staff immediately so that we can take appropriate
          measures based on your request.
        </div>
        <div>
          Please use complex passwords to assist us in ensuring the security of
          your account. We will make every effort to ensure the security of any
          information you send to us. If our physical, technical, or managerial
          protection facilities are compromised, resulting in unauthorized
          access, disclosure, alteration, or damage to information, leading to
          damage to your legitimate rights and interests, we will bear the
          corresponding legal responsibilities.
        </div>
        <div>
          5. In the event of an unfortunate personal information security
          incident, we will inform you in accordance with the requirements of
          laws and regulations: the basic situation and possible impact of the
          security incident, the disposal measures we have taken or will take,
          the advice on how you can prevent and reduce risks on your own,
          remedies for you, etc. We will inform you of the relevant
          circumstances of the event by email, letter, telephone, notification,
          etc. When it is difficult to inform the personal information subjects
          one by one, we will take a reasonable and effective way to publish an
          announcement. At the same time, we will also report the handling of
          personal information security incidents in accordance with the
          requirements of regulatory authorities.
        </div>
        <div>
          6. By submitting personal information through the Ccloud SaaS, you
          agree and authorize us to collect, use, share, and protect your
          personal information. If you wish to withdraw your authorization for
          specific reasons, please contact us promptly so that we can take
          appropriate action.
        </div>
        <div className={styles.title}>Your Rights</div>
        <div>
          You can access and manage your personal information in the following
          ways:
        </div>

        <div className={styles.title}>
          - Access to Your Personal Information
        </div>

        <div className={styles.title}>
          - Correction or Supplement of Your Personal Information
        </div>
        <div>
          When you find an error in the information we process about you, you
          have the right to request that we correct or supplement it. You may
          request correction or supplement by the methods set out in "1. Access
          to Your Personal Information".
        </div>

        <div className={styles.title}>
          - Deletion of Your Personal Information
        </div>
        <div>
          You may delete some of your information by the means set out in "1.
          Access to Your Personal Information".
        </div>
        <div>
          You may request us to delete personal information in the following
          circumstances:
        </div>
        <div>
          1、If our handling of personal information violates the applicable
          laws and regulations;
        </div>
        <div>
          2、If we collect and use your personal information without your
          explicit consent;
        </div>
        <div>
          3、If our handling of personal information seriously violates our
          agreement with you;
        </div>
        <div>
          4、If you no longer use our products or services, or you voluntarily
          cancel your account;
        </div>
        <div>5、If we stop providing you with products or services.</div>
        <div>
          If we decide to respond to your deletion request, we will also try our
          best to notify the third parties who have obtained your information
          from us and request that they delete it promptly, unless otherwise
          provided by the applicable laws and regulations, or these third
          parties have obtained your independent authorization.
        </div>
        <div className={classNames(styles.bold, styles.underline)}>
          After you delete your personal information, we may not be able to
          immediately delete the corresponding information from our backup
          systems as required by the applicable laws and regulations and due to
          technical requirements for different types of information. Prior to
          deletion from our backup systems, we will only store the information
          and implement necessary security measures in accordance with
          regulatory requirements.
        </div>

        <div className={styles.title}>- Delete account</div>
        <div>
          If you need to terminate your use of Carbonstop Products/Services, you
          can contact us through the contact information listed in this Policy
          to apply for deletion of your account.
        </div>
        <div>
          After you voluntarily delete your account, we will stop providing
          products or services. Your personal information will be deleted or be
          anonymized with the deletion of your account in accordance with the
          applicable laws and regulations.
        </div>

        <div className={styles.title}>- Withdrawal of Consent</div>
        <div>
          You can contact us through the contact information listed in this
          Policy to request the withdrawal of your previously granted consent.
          Please note that after withdrawing your consent, we will no longer
          process the relevant personal information and will not be able to
          provide the corresponding functions or services. However, your
          decision to withdraw consent will not affect the processing of
          personal information based on your prior authorization.
        </div>

        <div className={styles.title}>
          - Automatic decision making of constraint information system
        </div>
        <div>
          In some business functions of our products and services, we may only
          make decisions based on non-manual automatic decision-making
          mechanisms including information systems, algorithms, etc. If these
          decisions significantly affect your legitimate rights and interests,
          you have the right to ask us to explain, and we will also provide a
          method of appeal without infringing on our trade secrets or other
          users’ rights and interests, or the public interest.
        </div>

        <div className={styles.title}>- Respond to your above request</div>
        <div>
          For security purposes, you may be required to provide a written
          request or otherwise prove your identity. We may ask you to verify
          your identity before processing your request.
        </div>
        <div>
          In the following situations, we will not be able to respond to your
          request as required by laws and regulations:
        </div>
        <div>
          1、The information is related to national security or defense
          security.
        </div>
        <div>
          2、The information is related to public safety, public health or
          significant public interests.
        </div>
        <div>
          3、The information is related to criminal investigation, prosecution,
          trial, and enforcement of judgments.
        </div>
        <div>
          4、Where we have ample evidence to show that you have malicious intent
          or abuses his/her rights.
        </div>
        <div>
          5、Where responding to your request will bring about grave harm to
          your own legitimate rights and interests, or those of other
          individuals or organizations.
        </div>
        <div>6、Where trade secrets are involved.</div>

        <div className={styles.title}>
          How we process minors&apos; Personal Information
        </div>
        <div>
          Our products, websites, and services are primarily designed for
          adults. Without the consent of parents or guardians, minors are not
          allowed to create their own user accounts.
        </div>
        <div>
          For cases where a minor&apos;s Personal Information is collected with
          the consent of a parent or guardian, we will only use or share this
          information as permitted by the applicable laws and regulations, with
          the explicit consent of the parent or guardian, or as necessary to
          protect the minors.
        </div>
        <div>
          Although the definition of minors varies in different laws and
          customs, we consider anyone under the age of 14 to be a minor. If we
          find that we have collected the personal information of minors without
          obtaining verifiable parental consent, we will try to delete such data
          as soon as possible.
        </div>

        <div className={styles.title}>
          How your personal information is transferred globally
        </div>
        <div>
          The Personal Information we collect and generate within the territory
          of the People's Republic of China will be stored in the territory of
          the People's Republic of China, except in the following cases:
        </div>
        <div>
          1、Where there are explicit provisions in laws and regulations.
        </div>
        <div>
          2、We have informed you about relevant information regarding overseas
          recipients (such as the overseas recipient's name, contact
          information, purposes, methods, types, and the way and procedure for
          you to exercise your rights over your personal information to the
          overseas recipient) and obtained your explicit consent.
        </div>
        <div>
          Under the above circumstances, we will ensure that your personal
          information will be protected with sufficient equivalent protection
          within the territory of the People's Republic of China in accordance
          with this Policy.
        </div>

        <div className={styles.title}>How we update this Policy</div>
        <div>
          This Policy may be updated, revised, amended, or modified as
          appropriate from time to time.
        </div>
        <div>
          Without your express consent, we will not limit your rights hereunder.
        </div>
        <div>
          In the event of any updates, changes, or amendments to any provisions
          in this Policy, we will notify you of changes in this Privacy Policy
          by posting the updated version on our website or through other means.
          Please visit our site to keep updated with the latest Privacy Policy.
          If you continue to use Carbonstop Products/Services after such
          changes, you are deemed to accept the revised privacy policy and shall
          be bound by it.
        </div>
        <div>
          In the event of any material change, we will publish a more obvious
          notice (including notifications on our website).
        </div>
        <div>
          Material changes referred to in this Policy include, but not limited
          to:
        </div>
        <div>
          1、Major changes in our service mode, e.g. the purpose of processing
          personal information, the type of processed personal information, and
          how personal information is used;
        </div>
        <div>
          2、Major changes in our ownership structure, organizational structure,
          e.g. the change of owners due to business adjustments, merger and
          acquisition;
        </div>
        <div>
          3、Changes of the main object which personal information is publicly
          disclosed to, shared with, or transferred to;
        </div>
        <div>
          4、Significant changes in your rights to participate in the processing
          of personal information and how you exercise such rights;
        </div>
        <div>
          5、Change of our responsible department, contact information, and
          complaint channel for personal information security;
        </div>
        <div>
          6、When a personal information security impact assessment report
          indicates high risks.
        </div>
        <div>
          We will archive the old versions of this Privacy Policy for your
          future reference. If you continue to use Carbonstop Services after
          this Policy is revised, it means you have fully read, understood, and
          accepted the revised Policy and shall be bound by it.
        </div>
        <div className={styles.title}>How to contact us</div>
        <div>
          If you have any questions, comments, or suggestions regarding this
          Privacy Policy, you can contact us through the following ways:
        </div>
        <div className={styles.contactInfo}>Email: mail@carbonstop.com</div>
        <div className={styles.contactInfo}>Phone: +86 (010) 50973498</div>
      </div>
    </div>
  );
}

export default PrivacyPolicyZH;
